ci_states.state("audiences", {
  url: "/data_direct/regional",
  templateUrl: "partials/audience/audience_view.html",
  controller: "AudienceViewController",
  ncyBreadcrumb: { label: "Regional", parent: "data_direct" },
});

ci_states.state("data_direct", {
  url: "/data_direct",
  ncyBreadcrumb: { label: "Datadesk" },
  controller: ($rootScope, $scope, $state) => {
    $state.go($rootScope.session.landing_page);
  },
});
